import {ASSESSMENT_MANDATORY_CONFIG} from '../../../util/patientContextUtil';
import _ from 'lodash';
import {MAP_ZOOM_LEVEL} from "../../../util/mapCreator/mapUtils";

export const DEFAULT_PATIENT_VALUE = {
    demographicPosition: 'right',
};

export const DEFAULT_REGISTRATION_VALUE = {
    feedback: true,
};

export const DEFAULT_LOCATION_VALUE_CLEANING_REQUEST = {
    ED: {
        enabled: true,
        auto: false,
    },
    IP: {
        enabled: true,
        auto: false,
    },
};

export const DEFAULT_LEVEL_VALUE_CLEANING_REQUEST = {
    level1: 60,
    level2: 120,
    level3: 420,
};

export const DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST = {
    discharge: true,
    transfer: true,
    offWard: true,
};

export const DEFAULT_OBS_CFG_VALUE = {
    retrospective: false,
};

export const DEFAULT_INDICATOR_LEVEL_SETTINGS = {
    enableDuringZoom: false,
    scaleLocation: 'near-button',
    scaleVariant: 'linear',
    showAlertOnReducedVisibility: false,
    indicatorVisibleOnCards: false,
};

export const DEFAULT_ASSESSMENTS_VALUE = {
    mandatory: {
        enabled: false,
        showBorderline: ASSESSMENT_MANDATORY_CONFIG.DONT_SHOW_BORDERLINE,
        modalDisplay: ASSESSMENT_MANDATORY_CONFIG.DONT_DISPLAY_MODAL_ON_DISCHARGE,
    },
    ED: {
        mandatory: [],
        suggested: [],
    },
    INPATIENT: {
        mandatory: [],
        suggested: [],
    },
};
//hardcoded hospital for Agyle 'Pole' and 'BourneMoth'
export const extDashboardCfgHospitalsFilter = ['R0D01','R0D02'];

const HOSPITAL_EXT_DASHBOARD_VALUE = {
    ambulanceWaiting: {id:"ambulanceWaiting", name: 'Ambulance Waiting', locations:[] },
    uhdCohort: {id:"uhdCohort",name: 'UHD Cohort', locations:[] } ,
    waitingToBeSeen: {id:"waitingToBeSeen",name: 'Waiting To Be Seen (ED)', locations:[] },
    waitingToBeSeenUTC: {id:"waitingToBeSeenUTC",name: 'Waiting To Be Seen (UTC)', locations:[] },
}

export const DEFAULT_EXT_DASHBOARD_VALUE
    = Object.fromEntries(extDashboardCfgHospitalsFilter.map(key =>
    [key, _.cloneDeep(HOSPITAL_EXT_DASHBOARD_VALUE)]))


export const DEFAULT_LOCAL_SETTINGS_VALUE =  // db.getCollection("localSystemConfig").find({})
    // {
    // "_id" : "generatedDocuments",
    // "groupTitle" : "Generated documents",
    // "list" :
    [
        {
            "description" : "CasCard",
            "active" : true,
            "value" : false,
            "stage" : "FORTRUS",
            "approvedLive" : true,
        },
        {
            "description" : "DischargeLetter",
            "active" : true,
            "value" : false,
            "stage" : "PAID",
            "approvedLive" : true,
        },
        {
            "description" : "CasCardLite",
            "active" : true,
            "value" : true,
            "stage" : "FREE",
            "approvedLive" : false,
        }
    ];
// };

export const DEFAULT_WHITEBOARD_VALUE = {
        zoomLevelIndicator: {}, // key - hospital id, val - { [ward.code]: DEFAULT_INDICATOR_LEVEL_SETTINGS-like-structure }
    };